module.exports = __webpack_public_path__ + "img/left_ring.3ce3ee8e.png";